import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

import {UserAdLastVisitResponse} from "@numizmat/services-models/core";

@Injectable({
  providedIn: 'root'
})
export class UserAdLastVisitStateService {
  private allLastVisits$: BehaviorSubject<UserAdLastVisitResponse[] | undefined> =
    new BehaviorSubject<UserAdLastVisitResponse[] | undefined>(undefined);

  public isVisitsLoaded: boolean = false;

  public getAllLastVisits(): Observable<UserAdLastVisitResponse[] | undefined> {
    return this.allLastVisits$.asObservable();
  }

  public setAllLastVisits(allLastVisits: UserAdLastVisitResponse[]): void {
    this.allLastVisits$.next(allLastVisits);
  }

  public addLastVisit(newVisit: UserAdLastVisitResponse): void {
    const currentVisits: UserAdLastVisitResponse[] | undefined = this.allLastVisits$.value;
    if (!currentVisits) {
      this.allLastVisits$.next([newVisit]);
    } else {
      const alreadyExists = currentVisits
        .find(v => v.adId === newVisit.adId);
      if (alreadyExists) {
        const updatedVisits = [
          newVisit,
          ...currentVisits.filter(v => v.adId !== newVisit.adId)
        ];
        this.allLastVisits$.next(updatedVisits);
      } else {
        const updated = [newVisit, ...currentVisits];
        const trimmed = updated.slice(0, 7);
        this.allLastVisits$.next(trimmed);
      }
    }
  }
}
